const stepperStatus = {
  DONE: 'done',
  IN_PROGRESS: 'in-progress',
  FUTURE: 'future',
};

export default stepperStatus;
